<template>
	<div class="cases-listing-table">
		<BaseTableReportHistoryTable :tableData="tableData" ref="usedHistoryTableRef" @filter_submit="filterSubmit($event)" />
	</div>
</template>
<script>
import BaseTableReportHistoryTable from '@/views/CreditReports/CreditBalance/Tables/BaseTableReportHistory/BaseTableReportHistoryTable'

export default {
	props: ['listBaseTableReportHistory'],
	components: {
		BaseTableReportHistoryTable
	},
	data() {
		return {
			tableData: [],
		}
	},
	computed: {
	},
	watch: {
		listBaseTableReportHistory: {
			handler(newVal) {
				this.tableData = newVal
			},
			immediate: true
		},
	},
	methods: {
		filterSubmit(event) {
			this.$emit('filter_submit', event)
		},
	},
}
</script>